import request from "../../utils/request";
import server from "./config";

export default {
    /**
     * 患者端根据历史商品订单重新开具处方
     * @param {Object} data - { consultId: 新问诊ID, orderId: 原商品订单ID }
     * @returns {PrescriptionRespBody} 含 id(新处方ID)、doctorName、productList、totalPrice 等
     */
    repurchase: data => {
        return request({
            url: `${server.MS_PATIENT_CONSUMMER}/prescription/1/repurchase`,
            method: "post",
            data
        });
    }
};



// WEBPACK FOOTER //
// ./src/api/modules/prescription.js